<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-coupon-dialog-form">
    <ng-container *ngIf="data.isNew">
      <mat-form-field>
        <mat-label
          >Coupon Code (Up to 16 characters long, must be unique)</mat-label
        >
        <input
          matInput
          name="data.couponCode"
          [(ngModel)]="data.couponCode"
        /> </mat-form-field
      ><br />
    </ng-container>
    <ng-container *ngIf="!data.isNew">
      <b>Coupon Code: </b> {{ data.couponCode }}
      <br />
    </ng-container>
    <mat-form-field>
      <mat-label>Description (required)</mat-label>
      <input
        matInput
        name="data.description"
        [(ngModel)]="data.description"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Coupon Start Date (can be null)</mat-label>
      <input
        matInput
        [matDatepicker]="startDatePicker"
        name="data.startDate"
        [(ngModel)]="data.startDate"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="startDatePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Coupon Expiration Date (required)</mat-label>
      <input
        matInput
        [matDatepicker]="endDatePicker"
        name="data.expirationDate"
        [(ngModel)]="data.expirationDate"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="endDatePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #endDatePicker></mat-datepicker> </mat-form-field
    ><br />
    <ng-container>
      <mat-checkbox name="data.oneTimeUse" [(ngModel)]="data.oneTimeUse"
        >One Time Use Coupon?</mat-checkbox
      > </ng-container
    ><br />
    <mat-form-field>
      <mat-label>Coupon Type</mat-label>
      <mat-select
        name="data.couponType"
        style="width: 100%"
        [(ngModel)]="data.couponType"
      >
        <mat-option value="F">Free Trial</mat-option>
        <mat-option value="P">Percent Off</mat-option>
        <mat-option value="D">Dollars Off</mat-option>
      </mat-select> </mat-form-field
    ><br />
    <mat-form-field *ngIf="data.couponType == 'F'">
      <mat-label>Free Trial Length</mat-label>
      <input
        matInput
        name="data.freeTrialLength"
        [(ngModel)]="data.freeTrialLength"
      /> </mat-form-field
    ><br />
    <mat-form-field *ngIf="data.couponType == 'P'">
      <mat-label>Discount Percent</mat-label>
      <input
        matInput
        name="data.discountPercent"
        [(ngModel)]="data.discountPercent"
      /> </mat-form-field
    ><br />
    <mat-form-field *ngIf="data.couponType == 'D'">
      <mat-label>Discount Amount</mat-label>
      <input
        matInput
        name="data.discountAmount"
        [(ngModel)]="data.discountAmount"
      /> </mat-form-field
    ><br />
    <ng-container>
      <mat-checkbox name="data.active" [(ngModel)]="data.active"
        >Active</mat-checkbox
      > </ng-container
    ><br />
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Coupon
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
